import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="main_ftr">
      <div className="top_sec">
        <div className="loc_icon" />
        <p className="bbf cntct_info">
          845-200-3536 / 1 Hillcrest Center Dr, Spring Valley New York 10977
        </p>

        <div className="social_wrpr">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/company/omediadesign/"
          >
            <div className="ib social_item icon_wrpr linkdn" />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://dribbble.com/OmediaDesign"
          >
            <div className="ib social_item icon_wrpr drbl" />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/omedia_design/"
          >
            <div className="ib social_item icon_wrpr inst" />
          </a>
        </div>
      </div>

      <div className="df bslf copy_sec">
        <p className="left">
          © Copyright 2017 Omediadesign.com, Omedia Inc, All rights reserved
        </p>
        <p className="right">
          <button>Terms and conditions</button>
          <button>Privacy policy</button>
        </p>
      </div>
    </div>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js